import { CoverImageInputButton } from "@circle-react-uikit/CoverImageInput/CoverImageInputButton";
import type { RendererProps } from "@circle-react-uikit/ImageInput/ImageSelector";
import { CoverPreview } from "./CoverPreview";

export interface ImageInputRenderProps extends RendererProps {
  className?: string;
  variant?: "default" | "cover";
}

export const ImageInputRender = ({
  value,
  processing,
  className,
  variant,
  ...rest
}: ImageInputRenderProps) => {
  if (!value && !processing) {
    return <CoverImageInputButton {...rest} />;
  }

  return (
    <CoverPreview
      className={className}
      variant={variant}
      value={value}
      processing={processing}
      {...rest}
    />
  );
};
